import { __assign } from '../../_virtual/_tslib.js';
import React from 'react';
import { useDayPicker } from '../../contexts/DayPicker/useDayPicker.js';
import '../../contexts/DayPicker/DayPickerContext.js';

/**
 * Render a button HTML element applying the reset class name.
 */
var Button = React.forwardRef(function (props, ref) {
    var _a = useDayPicker(), classNames = _a.classNames, styles = _a.styles;
    var classNamesArr = [classNames.button_reset, classNames.button];
    if (props.className) {
        classNamesArr.push(props.className);
    }
    var className = classNamesArr.join(' ');
    var style = __assign(__assign({}, styles.button_reset), styles.button);
    if (props.style) {
        Object.assign(style, props.style);
    }
    return (React.createElement("button", __assign({}, props, { ref: ref, type: "button", className: className, style: style })));
});

export { Button };
//# sourceMappingURL=Button.js.map
